import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    // distinct selector so Angular 16's component ID does not collide with ConfirmDialogComponent (NG0912)
    selector: 'app-confirm-two-options-dialog',
    template: `
        <div class="modal-header">
            <h4 class="modal-title">{{ title }}</h4>
            <button class="close" type="button" aria-label="Close" (click)="activeModal.close(false)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" [innerHTML]="message"></div>
        @if (firstButtonName || secondButtonName || cancelButtonName) {
            <div class="modal-footer">
                @if (firstButtonName) {
                    <button class="btn btn-sm btn-primary" preventMultiClick (click)="activeModal.close(1)">
                        {{ firstButtonName }}
                    </button>
                }
                @if (secondButtonName) {
                    <button class="btn btn-sm btn-primary" preventMultiClick (click)="activeModal.close(2)">
                        {{ secondButtonName }}
                    </button>
                }
                @if (cancelButtonName) {
                    <button class="btn btn-sm btn-secondary" (click)="activeModal.close(false)">
                        {{ cancelButtonName }}
                    </button>
                }
            </div>
        } @else {
            <div class="modal-footer">
                <button class="btn btn-sm btn-primary mr-2" preventMultiClick (click)="activeModal.close(1)">
                    <fa-icon [icon]="['fas', 'check']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Yes' | translate }}
                </button>
                <button class="btn btn-sm btn-secondary" (click)="activeModal.close(false)">
                    <fa-icon [icon]="['fas', 'times']"></fa-icon>
                    &nbsp;&nbsp;{{ 'Cancel' | translate }}
                </button>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmTwoOptionsDialogComponent {
    public title: string;
    public message: string;
    public firstButtonName: string;
    public secondButtonName: string;
    public cancelButtonName: string;

    constructor(public activeModal: DialogRef) {}
}
